var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bimButton',_vm._b({staticClass:"button-big",attrs:{"size":"l"},on:{"click":function($event){return _vm.$emit('click')}}},'bimButton',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }